import {Button, notification, Popconfirm, Popover, Table, Tooltip, Typography} from "antd";
import moment from "moment/moment";
import {PREFERRED_DATETIME_FORMAT} from "../../util/time";
import _ from "lodash";
import {OrderedListOutlined, UndoOutlined} from "@ant-design/icons";
import {Message} from "./Message";
import React, {useState} from "react";
import {undoD365Upload} from "../../api/d365Api";
import sorters from "../../util/sorters";

const UploadsTable = ({
                        uploads,
                        scroll,
                        pagination,
                        loading,
                        setLoading,
                        permissions,
                        hideColumns,
                        disableUploads,
                        loadUploads,
                        setSelectedUpload,
                        setShowAdjustments,
                        notificationError
                      }) => {

  const [undoStatus, setUndoStatus] = useState(false);
  const uploadIsCompleted = u => u.status === 'COMPLETED';
  const uploadCanView = u => u.status === 'COMPLETED' || u.status === 'UNDONE';


  const loadAdjustments = exp => {
    setSelectedUpload(exp);
    setShowAdjustments(true);
  };

  const undoUpload = async (r) => {
    let res;
    try {
      setLoading(true);
      setUndoStatus(true);
      res = await undoD365Upload(r.ID);
      if (res) {
        if (res.error) {
          notificationError(res.error)
        } else if (res.status && res.status === "ok") {
          notification.success({
            message: 'Success',
            description: 'undo process event created!',
            placement: 'bottomRight',
          });
          loadUploads();
        } else {
          console.error(res)
          notificationError('Unknown error - see console');
        }
      } else {
        notificationError('No data from undoD365Upload');
      }
    } catch (e) {
      console.error(`Could not undo upload ${r.s3uploadName}`, e);
      notificationError('Unknown error - see console')
    } finally {
      setUndoStatus(false)
      setLoading(false)
    }
  }


  const columns = [
    {
      title: 'ID',
      width: 80,
      align: 'right',
      sorter: (a, b) => sorters.number(a.ID, b.ID),
      dataIndex: 'ID',
      hidden: hideColumns
    }, {
      title: 'Created',
      width: 165,
      sorter: (a, b) => sorters.date(a.CreatedAt, b.CreatedAt),
      render: r => (
        <Tooltip title={`Created by ${r.createdBy}`} placement="bottom" overlayInnerStyle={{width: '450px'}}>
          <Typography.Text>{moment(r.CreatedAt).format(PREFERRED_DATETIME_FORMAT)}</Typography.Text>
        </Tooltip>
      )
    },
    {
      title: 'Updated',
      width: 165,
      sorter: (a, b) => sorters.date(a.UpdatedAt, b.UpdatedAt),
      render: r => (
        <Tooltip title={`Updated by ${r.updatedBy}`} placement="bottom" overlayInnerStyle={{width: '450px'}}>
          <Typography.Text>{moment(r.UpdatedAt).format(PREFERRED_DATETIME_FORMAT)}</Typography.Text>
        </Tooltip>
      ),
      hidden: hideColumns
    },
    {
      title: 'Status',
      width: 125,
      dataIndex: 'status',
      sorter: (a, b) => sorters.string(a.status, b.status),
      render: r => _.capitalize(r)
    },
    {
      title: 'Upload Filename',
      width: 360,
      sorter: (a, b) => sorters.string(a.uploadName, b.uploadName),
      render: r => (
        <Tooltip title={`S3 Filename: ${r.s3UploadName}`} placement="bottom" overlayInnerStyle={{width: '450px'}}>
          <Typography.Text>{r.uploadName}</Typography.Text>
        </Tooltip>
      )
    },
    {
      title: 'Message',
      ellipsis: true,
      render: r => (<Message message={r.message}/>)
    },
    {
      title: 'Action',
      width: 210,
      key: 'action',
      fixed: 'right',
      hidden: permissions === null,
      render: (text, record) => (
        <>
          {permissions !== null && permissions.canManageD365 && (
            <>
              <Popconfirm
                title="Are you sure you want to undo this complete upload on Projector?"
                onConfirm={() => undoUpload(record)}
                okText="Yes"
                cancelText="No"
              >
                <Popover
                  placement="topRight"
                  trigger="hover"
                  content={(
                    <Typography>This will undo the complete uploaded adjustments on Projector!
                      Upload needs to be redone if needed. Please use with caution.</Typography>
                  )}
                >
                  <Button icon={<UndoOutlined/>}
                          style={{marginRight: 10}}
                          disabled={disableUploads || !uploadIsCompleted(record)}
                          loading={undoStatus}>Undo</Button>
                </Popover>
              </Popconfirm>
            </>
          )}
          <Button icon={<OrderedListOutlined/>}
                  disabled={!uploadCanView(record)}
                  onClick={() => loadAdjustments(record)}>View</Button>
        </>
      ),
    },
  ].filter(item => !item.hidden);

  return (
    <>
      <Table
        rowKey="ID"
        dataSource={uploads}
        columns={columns}
        scroll={scroll}
        pagination={pagination}
        size="small"
        loading={loading}
      />
    </>
  );
}

export {UploadsTable};